import { Box, CircularProgress, Typography } from '@mui/material'

export interface FullPageLoaderProps {
    /** Resolved copy — the logic layer owns i18n. */
    message: string
}

// Blocking progress overlay: dims the page and centres a card, leaving the content
// mounted underneath so the user keeps their place. Used while a request re-prices the
// screen in place (RN parity) rather than replacing it with a skeleton.
const FullPageLoader: React.FC<FullPageLoaderProps> = ({ message }) => (
    <Box
        sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 'modal',
            bgcolor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 3
        }}
    >
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                p: 3,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                maxWidth: 320
            }}
        >
            <CircularProgress size={40} sx={{ color: 'primary.main' }} />
            <Typography sx={{ fontSize: 14, color: 'textColors.primary', textAlign: 'center' }}>
                {message}
            </Typography>
        </Box>
    </Box>
)

export { FullPageLoader }
export default FullPageLoader
